/**
 * I passi del tutorial guidato del calendario Ordini fornitore.
 *
 * La pagina non e' una tabella ma un calendario, e le due finestre di riepilogo -
 * quella del singolo fornitore e quella dell'intera giornata - sono schermate a
 * se': qui si dice come aprirle, dentro la prima c'e' un tutorial suo.
 *
 * Nessun `before`: non ci sono menu ne' cassetti da preparare.
 */
const at = name => `[data-tour-scope="order-suppliers"] [data-tour="${name}"]`;

export function createOrderSuppliersTourSteps() {
	return [
		{
			body: 'Questo calendario mostra quando la merce deve arrivare dai fornitori. Gli ordini non nascono qui: si preparano dalla pagina Ordini, scegliendo per quali ordini cliente serve rifornirsi e entro quale data la merce deve essere consegnata. Il sistema raggruppa da solo il fabbisogno per fornitore e lo appoggia su quel giorno - quello che vedi qui sotto.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'A cosa serve questa pagina',
		},
		{
			body: "Le frecce spostano il periodo avanti e indietro, Today riporta a oggi. Ogni volta che cambi periodo l'elenco degli ordini viene richiesto da capo per le date che stai guardando: se una consegna non compare, controlla prima di essere nel mese giusto.",
			key: 'nav',
			placement: 'bottom',
			target: at('nav'),
			title: 'Muoversi nel tempo',
		},
		{
			body: 'Da qui si cambia la vista: mese, settimana, quattro giorni o singolo giorno. Il mese serve a vedere come sono distribuite le consegne, il giorno a lavorare su una data precisa quando i fornitori sono tanti.',
			key: 'view',
			placement: 'left',
			target: at('view'),
			title: 'Mese, settimana, giorno',
		},
		{
			body: "Ogni pastiglia e' un fornitore in un certo giorno, e l'etichetta dice fra parentesi quanti prodotti gli vanno ordinati. Il colore e' assegnato a caso e non significa niente: serve solo a distinguere una pastiglia dall'altra. Accanto al numero del giorno compare un'icona di stampante sulle date che hanno almeno un ordine, cosi' si individuano a colpo d'occhio anche senza leggere le pastiglie.",
			key: 'calendar',
			placement: 'top',
			target: at('calendar'),
			timeout: 250,
			title: 'Come si legge il calendario',
		},
		{
			body: "Cliccando una pastiglia si apre il riepilogo di quel fornitore: l'elenco dei prodotti da ordinargli, con quantita' e numero dell'ordine cliente da cui nascono. E' li' che si escludono le righe che non servono, si scarica il riepilogo e lo si manda al fornitore - e quella finestra ha un tutorial suo.",
			key: 'event',
			placement: 'bottom',
			target: `[data-tour-scope="order-suppliers"] .v-event`,
			timeout: 250,
			title: 'Il riepilogo di un fornitore',
		},
		{
			body: "Cliccando invece il numero del giorno - quello con l'icona di stampante - si apre il riepilogo dell'intera giornata: tutti i fornitori insieme, con il totale dei prodotti e da quanti fornitori arrivano. Li' i comandi sono tre: Scarica riepilogo, Scarica Excel e Invia tramite mail, e valgono per tutta la giornata in una volta. Prodotti esclusi e ordini cliente annullati restano fuori da quello che scarichi o mandi.",
			key: 'day',
			placement: 'bottom',
			target: `[data-tour-scope="order-suppliers"] .mdi-printer`,
			timeout: 250,
			title: "Il riepilogo dell'intera giornata",
		},
	];
}
